import { APPLY_POLICY_ADJUSTMENT_CHANGES } from '../../constants/actions/policy';

export function applyPolicyAdjustmentChanges(payload) {
    return {
        type: APPLY_POLICY_ADJUSTMENT_CHANGES,
        payload,
    };
}
